<template>
  <div id="interface">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'interface'
}
</script>




// WEBPACK FOOTER //
// src/views/system/interface/Interface.vue